import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinmagarpatta() {



  const cardData =
  {
    keyword: 'Mini Bus On Rent in Magarpatta City',
    heading: 'Sanavi Travels: Mini Bus On Rent in Magarpatta City',
    headingDescription: 'Sanavi Travels offers reliable Ertiga Rent in Daund Pune, providing safe, comfortable, and spacious transportation for families, small groups, corporate travelers, and pilgrims traveling between Daund and Pune. Our fleet of well-maintained Maruti Ertiga vehicles ensures ample seating, air-conditioning, and luggage space for a smooth and hassle-free journey. With professional chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for local travel, outstation trips, airport transfers, Shirdi visits, and family outings. Choose Sanavi Travels for trusted Ertiga rental services in Daund Pune, delivering comfort, safety, and a seamless travel experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s iconic 18th-century fort built by the Peshwas, featuring massive stone walls, grand gateways like Delhi Darwaza, and spacious courtyards. Though partly destroyed by fire, it stands as a symbol of Maratha heritage and valor. The evening light-and-sound show narrates Pune’s royal history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic monument tied to India’s freedom movement, where Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned. It now houses a museum displaying Gandhi’s personal artifacts and documents amidst serene gardens, making it a significant heritage site."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol, adorned with gold ornaments, draws thousands of devotees daily. Ganesh Chaturthi sees grand celebrations, music, and cultural events, highlighting its spiritual and social significance."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, situated on a hilltop near Pune, is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Shivaji Maharaj. Visitors can trek or drive to explore the fort, enjoy scenic Sahyadri views, and savor local delicacies like pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from basalt rock, it features monolithic pillars and a serene sanctum. Despite its urban location, it offers peace, meditation, and a glimpse into ancient craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts including traditional ornaments, musical instruments, and household antiques. The recreated Mastani Mahal is a highlight, offering cultural and historical insights into India’s heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views after climbing 103 steps. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era and includes smaller shrines and a museum."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for meditation, wellness therapies, and mindfulness. Spread across landscaped gardens, it attracts visitors seeking relaxation, rejuvenation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With arched bridges, water streams, and manicured lawns, it is perfect for morning walks, family outings, and photography."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune. Surrounded by hills, it offers scenic views, especially during monsoon. Visitors enjoy picnics, sunset views, and local snacks, making it a favorite weekend destination."
  }
]
,



"services": [
  {
    "name": "Mini Bus On Rent in Magarpatta City",
    "description": "Mini Bus On Rent in Magarpatta City provides reliable and convenient transportation solutions for groups of all sizes. Perfect for corporate outings, family trips, weddings, and events, the service ensures well-maintained vehicles, experienced drivers, and a comfortable travel experience. It emphasizes punctuality, safety, and hassle-free booking, making group travel in and around Magarpatta smooth and enjoyable."
  },
  {
    "name": "Mini Bus Hire Magarpatta",
    "description": "Mini Bus Hire Magarpatta offers flexible rental options for short and long trips. Ideal for office staff transportation, corporate tours, school trips, and family excursions, this service ensures comfortable seating, professional chauffeurs, and timely pickups. Customers can enjoy stress-free travel with a focus on convenience and reliability."
  },
  {
    "name": "AC Mini Bus Magarpatta",
    "description": "AC Mini Bus Magarpatta provides fully air-conditioned rides for a comfortable and refreshing travel experience. Suitable for summer travel, corporate trips, weddings, and family outings, the service offers spacious seating, well-maintained vehicles, and professional drivers to ensure smooth and pleasant journeys."
  },
  {
    "name": "Luxury Mini Bus Magarpatta",
    "description": "Luxury Mini Bus Magarpatta delivers premium travel experiences with stylish interiors, advanced amenities, and air-conditioned comfort. Perfect for VIP transportation, corporate events, weddings, and long-distance trips, this service combines elegance, safety, and punctuality for a top-notch journey."
  },
  {
    "name": "Corporate Mini Bus Magarpatta",
    "description": "Corporate Mini Bus Magarpatta caters to office staff transportation, business events, and corporate outings. With scheduled pickups, professional chauffeurs, and spacious buses, the service ensures reliable and comfortable travel for employees, clients, and business guests, enhancing corporate mobility."
  },
  {
    "name": "Office Staff Bus Magarpatta",
    "description": "Office Staff Bus Magarpatta provides organized transportation for daily office commutes and employee travel. Emphasizing safety, punctuality, and efficiency, it ensures smooth and comfortable rides with trained drivers and well-maintained mini buses, supporting businesses with consistent staff mobility."
  },
  {
    "name": "Affordable Mini Bus Magarpatta",
    "description": "Affordable Mini Bus Magarpatta offers budget-friendly group travel solutions without compromising on safety or comfort. Ideal for family trips, local tours, and corporate outings, the service provides well-maintained vehicles, reliable drivers, and flexible rental options at competitive rates."
  },
  {
    "name": "Chauffeur Driven Mini Bus",
    "description": "Chauffeur Driven Mini Bus ensures stress-free group travel with professional drivers handling navigation, traffic, and scheduling. Suitable for weddings, corporate tours, family trips, and sightseeing, it provides a safe, smooth, and comfortable travel experience for all passengers."
  },
  {
    "name": "Best Mini Bus Service Magarpatta",
    "description": "Best Mini Bus Service Magarpatta guarantees high-quality rental services with a focus on reliability, comfort, and customer satisfaction. Offering AC and non-AC options, chauffeur-driven services, and well-maintained vehicles, it is ideal for corporate, family, and leisure travel in and around Magarpatta."
  },
  {
    "name": "Event Mini Bus Magarpatta",
    "description": "Event Mini Bus Magarpatta provides seamless transportation solutions for weddings, parties, corporate events, and other group gatherings. With professional drivers, spacious buses, and timely service, it ensures that guests and participants travel comfortably and arrive on time."
  },
  {
    "name": "Group Travel Mini Bus",
    "description": "Group Travel Mini Bus Magarpatta is designed for families, friends, or corporate groups traveling together. It offers well-maintained vehicles, spacious seating, and experienced chauffeurs, ensuring a safe, convenient, and enjoyable group travel experience across Magarpatta and surrounding areas."
  },
  {
    "name": "Wedding Mini Bus Magarpatta",
    "description": "Wedding Mini Bus Magarpatta provides elegant and comfortable transportation for weddings, bridal parties, and guest transfers. With punctual service, professional drivers, and well-maintained buses, it ensures smooth travel for all wedding-related journeys."
  },
  {
    "name": "Tourist Mini Bus Pune",
    "description": "Tourist Mini Bus Pune offers convenient travel options for sightseeing, city tours, and leisure trips around Pune and Magarpatta. With air-conditioned comfort, spacious seating, and experienced drivers, it ensures an enjoyable and hassle-free travel experience for tourists and visitors."
  },
  {
    "name": "Online Bus Booking Magarpatta",
    "description": "Online Bus Booking Magarpatta allows customers to book mini buses conveniently through a user-friendly online platform. With instant confirmations, flexible schedules, and multiple vehicle options, it simplifies the rental process for corporate events, weddings, group tours, and personal travel."
  },
  {
    "name": "Magarpatta Travel Bus",
    "description": "Magarpatta Travel Bus provides flexible and reliable transportation for local and outstation trips. With AC and luxury options, chauffeur-driven vehicles, and spacious seating, it caters to families, tourists, and corporate clients seeking convenient and comfortable travel around Magarpatta and Pune."
  }
],
"tableData": [
  ["Mini Bus On Rent in Magarpatta City", "Mini Bus Hire Magarpatta"],
  ["AC Mini Bus Magarpatta", "Luxury Mini Bus Magarpatta"],
  ["Corporate Mini Bus Magarpatta", "Office Staff Bus Magarpatta"],
  ["Affordable Mini Bus Magarpatta", "Chauffeur Driven Mini Bus"],
  ["Best Mini Bus Service Magarpatta", "Event Mini Bus Magarpatta"],
  ["Group Travel Mini Bus", "Wedding Mini Bus Magarpatta"],
  ["Tourist Mini Bus Pune", "Online Bus Booking Magarpatta"],
  ["Magarpatta Travel Bus", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Mini Bus On Rent in Magarpatta City with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable mini bus rentals in Magarpatta City, perfect for group outings, corporate events, school trips, family excursions, and local tours."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Mini Buses",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced mini buses that ensure a smooth and enjoyable journey throughout Magarpatta City and nearby areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with routes in and around Magarpatta City, ensuring safe and timely travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for mini bus rentals in Magarpatta City, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your mini bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s schedule and travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All mini buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for mini bus rentals in Magarpatta City."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide mini buses on rent in Magarpatta City?',
    answer: 'Yes, Sanavi Travels offers reliable mini bus rentals in Magarpatta City for group travel, events, and local tours.'
  },
  {
    question: 'How can I book a mini bus in Magarpatta City?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are the mini buses well‑maintained and air‑conditioned?',
    answer: 'Yes, all mini buses provided by Sanavi Travels are clean, air‑conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are drivers experienced with Magarpatta City routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with local and nearby routes for safe and timely transportation.'
  },
  {
    question: 'Can I rent a mini bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half‑day, full‑day, and customized rental packages to meet your travel needs.'
  },
  {
    question: 'Are the vehicles sanitized before every trip?',
    answer: 'Yes, all mini buses are thoroughly cleaned and sanitized before every departure.'
  },
  {
    question: 'Is customer support available during the rental?',
    answer: 'Yes, our 24x7 customer support team is available throughout your mini bus rental.'
  },
  {
    question: 'What payment options are available for mini bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for mini bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on‑time pickups and reliable service for all mini bus bookings in Magarpatta City.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep More',
    feedback: 'Booked a mini bus in Magarpatta City for our group outing. Comfortable and well‑maintained vehicle with excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Great experience with the mini bus rental in Magarpatta City. On‑time pickup and friendly driver made our trip enjoyable.',
    rating: 5
  }
];































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Magarpatta City - Sanavi Travels",
  "description": "Rent a mini bus in Magarpatta City with Sanavi Travels. AC, luxury, and chauffeur-driven mini buses available for corporate, office staff, group travel, weddings, events, and tourist trips. Online booking available.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "90"
  }
};










  return (
    <div>
<Helmet>
  <title>
    Mini Bus On Rent in Magarpatta City | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Rent a mini bus in Magarpatta City with Sanavi Travels. AC, luxury, and chauffeur-driven mini buses available for corporate, office staff, group travel, weddings, events, and tourist trips. Online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/116.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinmagarpatta;